import {
  Breadcrumbs,
  Typography,
  Link,
  Stack,
  TablePagination,
} from "@mui/material";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { useDistribuicaoEpiListaViewModel } from "../../viewModels/distribuicao_epi_lista_view_model";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import { useMemo } from "react";
import { GenerateGestaoDistribuicaoEpiColumns } from "./columns";
import { GestaoDistribuicaoEpi } from "../../../domain/models/gestao_distribuicao_epi";
import { GestaoDistribuicaoEpiModal } from "./components/gestao_distribuicao_epi_modal";
import { ValidacaoFuncionarioModal } from "./components/validacao_funcionario_modal";

import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { VisualizacaoBiometriaModal } from "./components/visualizacao_biometria_modal";
import { VisualizacaoGryfoAuditaModal } from "./components/visualizacao_gryfo_audit_modal";
import { VisualizarItensModal } from "./components/visualizar_Itensmodal";


export const DistribuicaoEpiLista = () => {
  const viewModel = useDistribuicaoEpiListaViewModel();

  const columns = useMemo(() => {
    return GenerateGestaoDistribuicaoEpiColumns({
      onActionEdit: viewModel.handleCadastroGestaoDistribuicaoEpiModalOpenState,
      onActionDelete: viewModel.handleDeleteGestaoDistribuicaoEpiModalOpenState,
      onActionValidate: viewModel.handleValidacaoFuncionarioModalOpenState,
      onActionVisualize: viewModel.handleActionVisualize,
      onActionAuditoria: viewModel.handleActionAuditoria,
      onActionViewItems: viewModel.handleAbrirVisualizacao,
    });
  }, [viewModel.handleAbrirVisualizacao, viewModel.handleActionAuditoria, viewModel.handleActionVisualize, viewModel.handleCadastroGestaoDistribuicaoEpiModalOpenState, viewModel.handleDeleteGestaoDistribuicaoEpiModalOpenState, viewModel.handleValidacaoFuncionarioModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[115px]">
                <PrimaryButton
                  startIcon={
                    <DynamicIcon
                      nameIcon="AddRounded"
                      size={25}
                      className="text-white"
                    />
                  }
                  onMouseDown={(e) => {
                    viewModel.handleCadastroGestaoDistribuicaoEpiModalOpenState(
                      null,
                      true,
                    );
                    e.preventDefault();
                  }}
                >
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Gestão de EPI
          </Link>
          <Typography className="text-primary-green">
            Distribuição de EPI
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Distribuição de EPI
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2"></div>
          </div>
        </div>
        {viewModel.errorMessage !== undefined ? (
          <div className="w-full">
            <AlertError
              messageErro={viewModel.errorMessage}
              onTryAgain={viewModel.handleReload}
            />
          </div>
        ) : (
          <>
            <Header
              idsGestaoEpi={viewModel.filters.idsGestaoEpi}
              idsFuncionarios={viewModel.filters.idsFuncionarios}
              ca={viewModel.filters.ca}
              dataEntrega={viewModel.filters.dataEntrega}
              gestaoRecebimentoEpiDropdown={
                viewModel.gestaoRecebimentoEpiDropdown
              }
              funcionariosDropdown={viewModel.funcionariosDropdown}
              onGestaoEpiChange={viewModel.handleGestaoEpiChange}
              onFuncionariosChange={viewModel.handleFuncionariosChange}
              onCaChange={viewModel.handleCaChange}
              onDataEntregaChange={viewModel.handleDataEntregaChange}
              onClearFilters={viewModel.handleClearFilters}
            />

            <Stack spacing={0}>
              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                onRowsPerPageChange={(e) =>
                  viewModel.handleRowsPerPageChange(parseInt(e.target.value))
                }
              />

              <StyledDataGrid
                tableName="controle_distribuicao_epi"
                disableColumnMenu={false}
                getRowId={(row: GestaoDistribuicaoEpi) =>
                  row.idGestaoDistribuicaoEpi
                }
                textSize="pequeno"
                columns={columns}
                loading={viewModel.loading}
                disableRowSelectionOnClick={true}
                disableOutlineOnClick={true}
                rows={viewModel.gestaoDistribuicaoEpiLista}
                rowCount={viewModel.gestaoDistribuicaoEpiLista.length}
                getRowHeight={() => "auto"}
                pageSizeOptions={[10, 25, 50, 100]}
                paginationMode="server"
                paginationModel={{
                  page: viewModel.pagination.page,
                  pageSize: viewModel.pagination.rowsPerPage,
                }}
              />

              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                onRowsPerPageChange={(e) =>
                  viewModel.handleRowsPerPageChange(parseInt(e.target.value))
                }
              />
            </Stack>
          </>
        )}
      </div>

      {/* Modal */}
      <GestaoDistribuicaoEpiModal
        open={viewModel.gestaoDistribuicaoEpiCadastroModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedDistribuicaoEpi={viewModel.selectedDistribuicaoEpi}
        gestaoRecebimentoEpiDropdown={viewModel.gestaoRecebimentoEpiDropdown}
        funcionariosDropdown={viewModel.funcionariosDropdown}
        centroCustoDropdown={viewModel.centroCustoDropdown}
        centroCustoSaidaDropdown={viewModel.centroCustoSaidaDropdown}
        onClose={() =>
          viewModel.handleCadastroGestaoDistribuicaoEpiModalOpenState(
            null,
            false,
          )
        }
        handleValidacaoFuncionario={
          viewModel.handleValidacaoFuncionarioModalOpenState
        }
        cargosDropdown={viewModel.cargosDropDown}
        onSubmit={viewModel.handleGestaoDistribuicaoEpiSubmit}
        onLoadEpisPorCentroCusto={viewModel.loadGestaoEpiDropdown}
        OnActionQuantidadeChange={viewModel.handleQuantidadeChange}
        distribuicaoEpiItem={viewModel.distribuicaoEpiItemLista}
        onInclude={viewModel.handleIncludeGrid}
        onRemoveItem={viewModel.handleRemoveGridItem}
      />

      <ValidacaoFuncionarioModal
        open={viewModel.validacaoFuncionarioModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={() =>
          viewModel.handleValidacaoFuncionarioModalOpenState(null, false)
        }
        onError={viewModel.handleValidacaoFuncionarioError}
        onSubmit={viewModel.handleValidarFuncionarioSubmit}
      />
      <VisualizacaoBiometriaModal
        open={viewModel.modalImagemOpen}
        loading={viewModel.loading} 
        imagemUrl={viewModel.imagemUrl} 
        onClose={viewModel.handleCloseModalImagem}
        selectedDistribuicaoEpi={viewModel.selectedDistribuicaoEpi ?? null}
      />
      <VisualizarItensModal
          open={viewModel.modalVisualizarAberto}
          onClose={() => {
            viewModel.setModalVisualizarAberto(false);
            viewModel.setDistribuicaoParaVisualizar(null);
          }}
          distribuicaoSelecionada={viewModel.distribuicaoParaVisualizar}
          dropdownEpis={viewModel.gestaoRecebimentoEpiDropdown}
        />
      <VisualizacaoGryfoAuditaModal
        open={viewModel.gryfoAuditOpen}
        loading={viewModel.loading} 
        imagemUrl={viewModel.imagemUrl} 
        onClose={viewModel.handleCloseModalGryfoAudit}
        auditoriaGryfo={viewModel.selectedGryfoAudit ?? null}
      />

      <DeleteDialog
        open={viewModel.gestaoDistribuicaoEpiDeleteModal}
        title="Você realmente deseja excluir este item?"
        onClose={() =>
          viewModel.handleDeleteGestaoDistribuicaoEpiModalOpenState(null, false)
        }
        onDelete={() => viewModel.handleGestaoDistribuicaoEpiDeleteSubmit()}
      />
    </>
  );
};
